/* global axios */
import ApiClient from './ApiClient';

class VoipSettingsAPI extends ApiClient {
  constructor() {
    super('voip_settings', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  updateTranscription(payload) {
    // payload: { voip_transcription_enabled, voip_transcription_model,
    //            voip_transcription_language, voip_transcription_summary_auto,
    //            voip_business_context }
    // Keys are never accepted from the browser UI for white-label runtime.
    return axios.put(this.url, payload);
  }

  // Fase 2: update generico usado por TabGeral (business_types etc).
  // Aceita qualquer subset dos params validados no controller.
  update(payload) {
    return axios.put(this.url, payload);
  }

  // Static transcription models (audio engine). source is always 'static'.
  // Returns { models: [{name, display_name, experimental, ...}], source: 'static' }
  availableModels() {
    return axios.get(`${this.url}/available_models`);
  }
}

export default new VoipSettingsAPI();
